import { Stack } from '@mui/material'
import { BUTTON_SIZE, BUTTON_TYPE, COLORS, DSButton } from '@repo/design-system/index'
import { QIcon_chevron_left } from '@repo/icons/index'
import { useState } from 'react'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { APP_SCREEN_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_ai_speaking, n_common } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import { useAITutorStack } from '../../../pages/[lang]/webview/ai-tutor'
import { useCreateRolePlayStore } from '../../../store/useCreateRolePlayStore'
import { usePersonaStore } from '../../../store/usePersonaStore'
import Situation from './custom_role_play/Situation'
import Summary from './custom_role_play/Summary'
import WithWhom from './custom_role_play/WithWhom'
import {
  getCompanyTypeName,
  getExperienceDurationName,
  getGenderName,
  getIntimacyName,
  getKey,
  getPronunciationName,
  getRelationshipName,
  getToneName,
} from './custom_role_play/with_whom/getNames'

const AITutorCreateCustomRolePlay = () => {
  const [step, setStep] = useState(0)
  const length = 3

  const [isLoading, setIsLoading] = useState(false)

  const { personaId, purposeIds, customPurpose, background } = useCreateRolePlayStore()
  const { personas } = usePersonaStore()
  const getFullUrl = useReturnFullUrl()

  const { useAITutorFlow } = useAITutorStack()
  const { push } = useAITutorFlow()
  const { locale, t } = useTranslation()

  const router = useAppRouter({ stackPush: push, browserDetect: true })

  const onPrev = () => {
    if (step === 0) {
      return
    }
    setStep((prev) => prev - 1)
  }
  const onNext = async () => {
    if (!validateStep(step)) {
      return // validation 실패하면 넘어가지 않음
    }

    if (length - 1 === step) {
      setIsLoading(true)
      const persona = personas.find((x) => x.id === personaId)

      // ▶️ 일단 preset으로 하기로 함. 근데 그럼 아래 있는 것들은 안필요한가?

      const personaPayload = {
        id: personaId,

        company_type: getCompanyTypeName(persona.companyTypeId, 'en'),
        experience_duration: getExperienceDurationName(persona.experienceDurationId, 'en'),
        relationship: getRelationshipName(persona.relationshipId, 'en'),
        intimacy: getIntimacyName(persona.intimacyId, 'en'),
        tone: getToneName(persona.toneId, 'en'),
        tone_id: persona.toneId,
        pronunciation: getPronunciationName(persona.pronunciationId, 'en'),
        gender: getGenderName(persona.genderId, 'en'),

        name: persona.name,
        additional_info: persona.additionalInfo,
        ackground: persona.background,
      }

      // const purposesText = purposeIds.map((id, index) => getPurposeName(id, 'en')).join(',')

      const situationPayload = {
        purpose: getKey('purpose', purposeIds[0]),
        custom_purpose: customPurpose,
        background: background,
      }

      console.log('▶️situation payload', situationPayload)
      console.log('personaPayload payload', personaPayload)

      // return
      const url = apis.aiTutor.roleplay.create()
      const resData = await axiosPost(url, {
        persona: personaPayload,
        situation: situationPayload,
      })

      console.log('resData ===>', resData)
      const {
        // ai_tutor_roleplay,
        conversation_thread,
        room_token,
      } = resData.result

      // console.log(getFullUrl(urls.webview.aiTutor.roleplayLivekit()))
      // router.push(urls.webview.aiTutor.roleplayLivekit(), {
      //   appScreenName: APP_SCREEN_NAME.ROLEPLAY_LIVEKIT,
      //   appSendData: {
      //     url: getFullUrl(urls.webview.aiTutor.roleplayLivekit()),
      //     threadId: conversation_thread.id,
      //     roomToken: room_token,
      //     userName: currentUser.first_name || 'user',
      //   },
      // })

      const threadId = conversation_thread.id

      router.push(urls.webview.aiTutor.roleplay(threadId), {
        appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
        appSendData: {
          url: getFullUrl(urls.webview.aiTutor.roleplay(threadId)),
        },
      })

      setIsLoading(false)
      return
    }

    setStep((prev) => prev + 1)
  }

  //귀찮아 질것 같은데.
  const validateStep = (step: number) => {
    switch (step) {
      case 0:
        return !!personaId // 0단계: persona 선택해야 함
      case 1:
        return purposeIds.length > 0 || customPurpose // 1단계: 목적 하나 이상 선택해야 함
      case 2:
        return true // 2단계: 추가 입력 필요 없으면 항상 통과
      case 3:
        return true // 마지막 저장 단계
      default:
        return false
    }
  }

  const isNextDisabled = !validateStep(step)
  const isPrevDisabled = step === 0

  return (
    <div className="flex flex-col " style={{ height: '100vh' }}>
      <div
        style={{
          height: `calc(52px + env(safe-area-inset-top))`,
          paddingTop: 'env(safe-area-inset-top)',
        }}
        className="flex flex-row items-center"
      >
        <div
          className="pl-[20px] pr-[20px] flex flex-col justify-center"
          style={{ cursor: 'pointer', height: '100%' }}
          onClick={() => {
            if (typeof window !== 'undefined' && window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'ROUTER_BACK' }))
            } else {
              router.back()
            }
          }}
        >
          <QIcon_chevron_left width={24} height={24} color={COLORS.BLACK} />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 pb-[80px]">
        {step === 0 && <WithWhom />}
        {step === 1 && <Situation />}
        {step === 2 && <Summary />}
      </div>

      <Stack
        spacing={2}
        direction="row"
        justifyContent="space-between"
        sx={{
          position: 'absolute',
          bottom: `calc(env(safe-area-inset-bottom) + 12px)`, // ← 여기!
          left: 0,
          width: '100%',
          px: 2,
        }}
      >
        {step !== 0 && (
          <div style={{ width: 100, minWidth: 100 }}>
            <DSButton onClick={onPrev} disabled={isPrevDisabled} size={BUTTON_SIZE.LG} type={BUTTON_TYPE.OUTLINE}>
              <DSButton.Label>{t(n_common.btn_back)}</DSButton.Label>
            </DSButton>
          </div>
        )}

        <DSButton onClick={onNext} disabled={isNextDisabled || isLoading} size={BUTTON_SIZE.LG}>
          <DSButton.Label>{step === length - 1 ? t(n_ai_speaking.aI_intro.btn1) : t(n_common.btn_next)}</DSButton.Label>
        </DSButton>
      </Stack>
    </div>
  )
}

export default AITutorCreateCustomRolePlay
